export default "__VITE_ASSET__086e6e3a__"